import { Observable, of as observableOf } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { OAuthGuestUser, OAuthTokenRequest } from '../models/auth';
import { User } from '../models/customer';
import { UserSave } from '../models/profile';
import { SignUp, SignUpNew } from '../models/signup';
import { httpClient } from '../shop/shop-context';
export class AccountService {
	private _url = 'connect/account';
	private _guest: OAuthGuestUser = null;

	isGuestUser(model: User): Observable<boolean> {
		if (this._guest) {
			return observableOf(this.getIsGuestUser(model.contractualPartner ? model.contractualPartner.id : model.customerId));
		} else {
			return this.getGuestUser().pipe(
				mergeMap(guest => {
					this._guest = guest;
					return observableOf(this.getIsGuestUser(model.contractualPartner ? model.contractualPartner.id : model.customerId));
				})
			);
		}
	}

	getGuestUserAuth(): Observable<OAuthTokenRequest> {
		if (this._guest) {
			return observableOf(this.getGuestUserAccountAuthRequest());
		} else {
			return this.getGuestUser().pipe(
				mergeMap(guest => {
					this._guest = guest;
					return observableOf(this.getGuestUserAccountAuthRequest());
				})
			);
		}
	}

	get(): Observable<User> {
		const url = `/${this._url}`;
		return httpClient.get<User>(url);
	}

	updateAccount(model: UserSave): Observable<User> {
		const url = `/${this._url}/updateAccount`;

		return httpClient.put<User>(url, model);
	}

	create(model: SignUp): Observable<boolean> {
		const url = `/${this._url}/registration`;
		return httpClient.post<boolean>(url, model);
	}

	registerPartner(model: SignUpNew): Observable<boolean> {
		const url = `/${this._url}/registration-partner`;
		return httpClient.post<boolean>(url, model);
	}

	requestRole(): Observable<any> {
		const url = `/${this._url}/request-role`;
		return httpClient.post<boolean>(url, null);
	}

	requestRoles(roles: string[], partnerId: number): Observable<any> {
		const url = `/${this._url}/request-roles`;
		return httpClient.post<boolean>(url, {
			roles,
			partnerId
		});
	}

	private getGuestUser(): Observable<OAuthGuestUser> {
		const url = `/${this._url}/getGuestUser`;
		return httpClient.get<OAuthGuestUser>(url);
	}

	getIsGuestUser(contractualPartnerId: number): boolean {
		return contractualPartnerId === this._guest.customerId;
	}

	private getGuestUserAccountAuthRequest(): OAuthTokenRequest {
		return {
			grant_type: 'password',
			username: this._guest.username,
			password: this._guest.password
		};
	}
}
